import { Controller } from 'stimulus';

// Two-level collapse for the "Support Entries by Type" table:
//   - org row click expands its type rows; collapsing also hides any
//     entry rows that were already open underneath
//   - type row click toggles its entry rows
//
// Org and type headers carry `data-support-by-type-toggle-key-param`
// (consumed via Stimulus action params). Type headers also carry
// `data-org-key`; entry rows carry `data-org-key` and `data-type-key`
// plus `data-row-kind="entry"`.
export default class extends Controller {
  toggleOrg({ params: { key }, target, currentTarget }) {
    if (target.closest('a, input')) return;
    if (!key) return;

    const escaped = this.cssEscape(key);
    const wasExpanded = currentTarget.getAttribute('aria-expanded') === 'true';

    if (wasExpanded) {
      this.element
        .querySelectorAll(`[data-org-key="${escaped}"]`)
        .forEach((row) => {
          row.classList.add('d-none');
          if (row.dataset.rowKind === 'type') {
            row.setAttribute('aria-expanded', 'false');
          }
        });
    } else {
      this.element
        .querySelectorAll(`[data-row-kind="type"][data-org-key="${escaped}"]`)
        .forEach((row) => row.classList.remove('d-none'));
    }

    currentTarget.setAttribute('aria-expanded', String(!wasExpanded));
  }

  toggleType({ params: { key }, target, currentTarget }) {
    if (target.closest('a, input')) return;
    if (!key) return;

    const escaped = this.cssEscape(key);
    const wasExpanded = currentTarget.getAttribute('aria-expanded') === 'true';

    this.element
      .querySelectorAll(`[data-row-kind="entry"][data-type-key="${escaped}"]`)
      .forEach((row) => row.classList.toggle('d-none'));

    currentTarget.setAttribute('aria-expanded', String(!wasExpanded));
  }

  cssEscape(value) {
    return window.CSS && CSS.escape ? CSS.escape(value) : value;
  }
}
